import { PropsWithChildren, useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';

interface CreatePortalProps {
  portalId?: string;
}

export const CreatePortal = ({
  portalId = 'portal',
  children,
}: PropsWithChildren<CreatePortalProps>) => {
  const [wrapperElement, setWrapperElement] = useState<HTMLElement | null>(
    null,
  );

  const createPortalELement = (portalId: string): HTMLElement => {
    const portalElement = document.createElement('div');
    portalElement.id = portalId;
    document.body.appendChild(portalElement);
    return portalElement;
  };

  useLayoutEffect(() => {
    let element: HTMLElement | null = document.getElementById(portalId);
    let elementCreated = false;

    if (!element) {
      elementCreated = true;
      element = createPortalELement(portalId);
    }
    setWrapperElement(element);

    return () => {
      if (elementCreated && element?.parentNode) {
        element.parentNode.removeChild(element);
      }
    };
  }, [portalId]);

  if (wrapperElement === null) return null;

  return createPortal(children, wrapperElement);
};
